class BxfDateRangePickerConstants {
    static STRING = {
        RANGE_PICKER_CONTAINER: 'bxf-date-range-picker__container',
        FOCUSED_CONTAINER: 'bxf-date-range-picker__container--focused',
        DISABLED_CONTAINER: 'bxf-date-range-picker__container--disabled',
        INVALID_CONTAINER: 'bxf-date-range-picker__container--invalid',
        WARNING_CONTAINER: 'bxf-date-range-picker__container--warning',
        SUCCESS_CONTAINER: 'bxf-date-range-picker__container--success',
        INSTRUCTIONAL_TEXT: 'bxf-date-range-picker__instructional-text',
        INSTRUCTIONAL_TEXT_COMPACT: 'bxf-date-range-picker__instructional-text--is-compact',
        START_INPUT_CONTAINER: 'bxf-date-range-picker__input-container-start',
        END_INPUT_CONTAINER: 'bxf-date-range-picker__input-container-end',
        MID_LABEL: '—',
        MID_LABEL_CONTAINER: 'bxf-date-range-picker__mid-label-container',
        MID_LABEL_CONTAINER_DISABLED: 'bxf-date-range-picker__mid-label-container--disabled',
        CALENDAR_BUTTON: 'bxf-date-range-picker__calendar-button',
        CALENDAR_BUTTON_CONTAINER: 'bxf-date-range-picker__calendar-button-container',
        CALENDAR_BUTTON_ASSISTIVE_TEXT: 'Calendar Button',
        LABEL: 'bxf-date-range-picker__label',
        REQUIRED_LABEL: 'bxf-date-range-picker__label--required',
        DISABLED_LABEL: 'bxf-date-range-picker__label--disabled',
        LABEL_COMPACT: 'bxf-date-range-picker__label--compact',
        LEFT_LABEL: 'bxf-date-range-picker__label-left',
        LEFT_LABEL_CONTAINER: 'bxf-date-range-picker__left-label-container',
        LEFT_LABEL_COMPACT: 'bxf-date-range-picker__label-left--compact',
        ERROR_MESSAGE: 'bxf-date-range-picker__message--error',
        WARNING_MESSAGE: 'bxf-date-range-picker__message--warning',
        SUCCESS_MESSAGE: 'bxf-date-range-picker__message--success',
        DEFAULT_US: 'Default, US',
        DATE_INPUT_REQUIRED: 'bxf-date-range-picker__label--required',
        CALENDAR_BUTTON_LABEL: 'Calendar Button',
        TODAY_RELATIVE: 'T',
        MMMM: 'MMMM',
        INPUT: 'input',
        INSTRUCTIONAL_TEXT_DATA_TEST: 'instructional-text',
        ASSISTIVE_TEXT_GROUP: 'group',
        ASSISTIVE_TEXT_START: 'start',
        ASSISTIVE_TEXT_END: 'end',
        ASSISTIVE_TEXT_START_LABEL: 'Start',
        ASSISTIVE_TEXT_END_LABEL: 'End',
    };
}

export { BxfDateRangePickerConstants as B };
